import React from "react";

import PrescricoesAgendamento from "../../../Components/PrescricoesAgendamento";

export default function PrescricoesVisualizar({
  prescricoes,
  loading,
  onPreview,
  onDownload,
}) {
  return (
    <PrescricoesAgendamento
      prescricoes={prescricoes}
      loading={loading}
      onPreview={onPreview}
      onDownload={onDownload}
    />
  );
}
